export const FormDataToJson = function (formData) {
  var object = {};
  formData.forEach(function(value, key){
      object[key] = value;
  });
  return object;
};



// WEBPACK FOOTER //
// ./src/utils/json/Json.js